 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"31243703febd6969ccb69e595ee85c0e876decfb","2":"56b84e54d267ff91272710b3f80bf9ff8cd56d6b","3":"098391ce592228d067e79aafa35fcf0438fa8881","4":"db5bef27d5c80a2802c141c3d34268d6e0a7c139","5":"43474bca3d485661f76c77ce83498f1d9dadbce6","6":"511b445a90c9f8a7ab2556b8dc00fdd8d558bca3","7":"76a344c79d0aa822f45dc70931f3b9e903b4a210","8":"a22cbe4e","9":"bbd75b5a8fb8b03951b1aa57e55611a9b38d77a1","10":"01dcb6a107c0e8a221178bd07b688af3889312de","11":"0c760d35db038b721a60056772b9ea419be69c6d","12":"4e9bdd18d9b6772654b309c7c2e2d1dc5ef03927","13":"cb6c1e0143f794b4e980eefa83ee5fab3f4435d6","14":"dd08d9beea851fd535b146d02fe8a00d5cd5d563","17":"component---node-modules-gatsby-plugin-offline-app-shell-js","18":"component---src-pages-404-js","19":"component---src-pages-admin-js","20":"component---src-pages-admin-panel-js","21":"component---src-pages-corporate-responsibility-de-js","22":"component---src-pages-corporate-responsibility-en-js","23":"component---src-pages-corporate-responsibility-nl-js","24":"component---src-pages-dev-404-page-js","25":"component---src-pages-index-de-js","26":"component---src-pages-index-en-js","27":"component---src-pages-index-nl-js","28":"component---src-pages-investment-focus-de-js","29":"component---src-pages-investment-focus-en-js","30":"component---src-pages-investment-focus-nl-js","31":"component---src-pages-jobs-de-js","32":"component---src-pages-jobs-en-js","33":"component---src-pages-jobs-nl-js","34":"component---src-pages-news-details-de-js","35":"component---src-pages-news-details-en-js","36":"component---src-pages-news-details-nl-js","37":"component---src-pages-news-overview-de-js","38":"component---src-pages-news-overview-en-js","39":"component---src-pages-news-overview-nl-js","40":"component---src-pages-portfolio-de-js","41":"component---src-pages-portfolio-en-js","42":"component---src-pages-portfolio-nl-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"bfdf3d205c3ca8d256a9","2":"62c5c4b541efe2908b9b","3":"9de63e19c0030cb954ec","4":"427d6fe6385fc1e40ead","5":"d3da32efe8b5f9443d06","6":"1248cb737aeb665b1eab","7":"ad129c69e0b59066e797","8":"57c632c0e18d09841b89","9":"adf66d28320740fad4ba","10":"cdb3e38154ab1b08c333","11":"642713c1a61b77ec41e5","12":"06926360b14863961871","13":"9f244381dbabd644e51f","14":"e0d0f0bfcad2a67960a8","17":"f8ccea166015ac3806cf","18":"4ade02d7e640d1d05d6d","19":"14bd9c9f9315e07ff2a5","20":"fb8335cb05f13ba7c06a","21":"53b133f22e9221c7820a","22":"bcab3e1c73a648b70490","23":"559501b050cf323ddf61","24":"667de22b736c35b54904","25":"620ad4bd3b52966fabcb","26":"33b4b114bc7e65c6ed26","27":"402fe47fc82e789b12f2","28":"f2b69ef604d87f6644c7","29":"df40241f47aa4b40ca68","30":"83f497c255d3b959ea66","31":"ed5fafbec90bc8eb3fd0","32":"4fffcae55687994f258e","33":"05f5f50cd2a352adb78e","34":"4d9a19a282eac9dc3062","35":"beb0bfadd11eb8ca90a1","36":"0cb0d0cbfffb75bb24cd","37":"9c2a9966b170c550ea09","38":"753b5af668a019872dd2","39":"250c564264e616029274","40":"62ea57eb1d7fb36371fe","41":"d0c7c9b9db727794f38d","42":"142dad73cc5bec96faa1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"31243703febd6969ccb69e595ee85c0e876decfb","2":"56b84e54d267ff91272710b3f80bf9ff8cd56d6b","3":"098391ce592228d067e79aafa35fcf0438fa8881","4":"db5bef27d5c80a2802c141c3d34268d6e0a7c139","5":"43474bca3d485661f76c77ce83498f1d9dadbce6","6":"511b445a90c9f8a7ab2556b8dc00fdd8d558bca3","7":"76a344c79d0aa822f45dc70931f3b9e903b4a210","8":"a22cbe4e","9":"bbd75b5a8fb8b03951b1aa57e55611a9b38d77a1","10":"01dcb6a107c0e8a221178bd07b688af3889312de","11":"0c760d35db038b721a60056772b9ea419be69c6d","12":"4e9bdd18d9b6772654b309c7c2e2d1dc5ef03927","13":"cb6c1e0143f794b4e980eefa83ee5fab3f4435d6","14":"dd08d9beea851fd535b146d02fe8a00d5cd5d563","17":"component---node-modules-gatsby-plugin-offline-app-shell-js","18":"component---src-pages-404-js","19":"component---src-pages-admin-js","20":"component---src-pages-admin-panel-js","21":"component---src-pages-corporate-responsibility-de-js","22":"component---src-pages-corporate-responsibility-en-js","23":"component---src-pages-corporate-responsibility-nl-js","24":"component---src-pages-dev-404-page-js","25":"component---src-pages-index-de-js","26":"component---src-pages-index-en-js","27":"component---src-pages-index-nl-js","28":"component---src-pages-investment-focus-de-js","29":"component---src-pages-investment-focus-en-js","30":"component---src-pages-investment-focus-nl-js","31":"component---src-pages-jobs-de-js","32":"component---src-pages-jobs-en-js","33":"component---src-pages-jobs-nl-js","34":"component---src-pages-news-details-de-js","35":"component---src-pages-news-details-en-js","36":"component---src-pages-news-details-nl-js","37":"component---src-pages-news-overview-de-js","38":"component---src-pages-news-overview-en-js","39":"component---src-pages-news-overview-nl-js","40":"component---src-pages-portfolio-de-js","41":"component---src-pages-portfolio-en-js","42":"component---src-pages-portfolio-nl-js"}[chunkId]||chunkId) + "." + {"0":"765a81f01e12a3d5bb0d","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
